import { defineMessages } from 'react-intl'
import { TableLocales } from '@web/walter-ui-kit/components/Table/types'

// ui-kit - src/components/Table/MobileSortingFilters
export const lang: TableLocales = defineMessages({
    sortTitle: {
        id: 'table.mobileSortingFilters.sort.inactive_title',
        defaultMessage: 'Sorting',
    },
    sortActiveTitle: {
        id: 'table.mobileSortingFilters.sort.active_title',
        defaultMessage: 'Sort by',
    },
    sortModalTitle: {
        id: 'table.mobileSortingFilters.sort.modal_title',
        defaultMessage: 'Sort by',
    },
    numberSortAscending: {
        id: 'table.mobileSortingFilters.sort.number-ascending',
        defaultMessage: 'Low to high',
    },
    numberSortDescending: {
        id: 'table.mobileSortingFilters.sort.number-descending',
        defaultMessage: 'High to low',
    },
    textSortA: {
        id: 'table.mobileSortingFilters.sort.text-a',
        defaultMessage: 'A',
    },
    textSortZ: {
        id: 'table.mobileSortingFilters.sort.text-z',
        defaultMessage: 'Z',
    },
    sortDone: {
        id: 'table.mobileSortingFilters.sort.done',
        defaultMessage: 'Done',
    },
    filterCaption: {
        id: 'table.mobileSortingFilters.filter.caption',
        defaultMessage: 'Filter',
    },
    filterTitle: {
        id: 'table.mobileSortingFilters.filter.title',
        defaultMessage: 'Filter',
    },
    filterDefault: {
        id: 'table.mobileSortingFilters.filter.default',
        defaultMessage: 'All',
    },
    filterDone: {
        id: 'table.mobileSortingFilters.filter.done',
        defaultMessage: 'Done',
    },
    tableNoData: {
        id: 'table.no_data',
        defaultMessage: "So far, there's nothing here",
    },
})
